module.exports = __webpack_public_path__ + "static/media/wix_text_logo.86a6d593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect_store/wix_text_logo.png
// module id = 1536
// module chunks = 0